'use client'

import { ForesightManager } from 'js.foresight'
import { type ReactNode, useEffect } from 'react'

export function ForesightProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    ForesightManager.initialize()
  }, [])

  return <>{children}</>
}
